module.exports = __webpack_public_path__ + "static/media/Willpower.f6e04c08.svg";